import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import type {AppState} from '@stores/AppState';
import type {AuditTemplate} from '../../../../stores/audit/types';
import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {DeleteIcon} from '../../../components/icons/DeleteIcon';
import {EditIcon} from '../../../components/icons/editor/EditIcon';
import {UnpublishIcon} from '../../../components/icons/UnpublishIcon';
import {ContextMenuInterface} from '../ContextMenuInterface';

export interface AuditRowOptionsProps extends ContextMenuInterface {
    template: AuditTemplate;
    onDeleteRequest: (template: AuditTemplate) => void;
    onEditRequest: (template: AuditTemplate) => void;
    onUnpublishRequest: (template: AuditTemplate) => void;
}

export const openAuditRowOptions = (
    appState: AppState,
    template: AuditTemplate,
    mousePositionParams: any,
    onDeleteRequest: (template: AuditTemplate) => void,
    onEditRequest: (template: AuditTemplate) => void,
    onUnpublishRequest: (template: AuditTemplate) => void,
) => {
    appState.setContextMenu({
        ...mousePositionParams,
        id: `audit-row-options-${template.id}`,
        type: 'audit-row-options',
        withOverlay: true,
        minWidth: 180,
        params: {template, onDeleteRequest, onEditRequest, onUnpublishRequest},
    });
};

export const AuditRowOptions = observer(({handleClose, isDark, template, onDeleteRequest, onEditRequest, onUnpublishRequest}: AuditRowOptionsProps) => {
    const isDraft = template.publicationState !== 'published';

    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                ...(isDraft ? [{
                    text: intl.get('common.edit').d('Edit'),
                    Icon: EditIcon,
                    onClick: () => {
                        onEditRequest(template);
                        handleClose();
                        return false;
                    },
                }] : [{
                    text: intl.get('common.unpublish').d('Unpublish'),
                    Icon: UnpublishIcon,
                    onClick: () => {
                        onUnpublishRequest(template);
                        handleClose();
                        return false;
                    },
                }]),
                {
                    text: intl.get('common.delete').d('Delete'),
                    Icon: DeleteIcon,
                    onClick: () => {
                        onDeleteRequest(template);
                        handleClose();
                        return false;
                    },
                },
            ]}
        />
    );
});
